/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overview_Reopen_TournamentInputs */



/**
* | output |
* | --- |
* | "Reopen Tournament" |
*
* @param {Overview_Reopen_TournamentInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_reopen_tournament = /** @type {((inputs?: Overview_Reopen_TournamentInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Reopen_TournamentInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rouvrir le tournoi")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reabrir torneo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Reabrir Torneio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riapri Torneo")
	return /** @type {LocalizedString} */ ("Reopen Tournament")
});